import toast from "react-hot-toast"

const apiClient = async (endpoint, method = "GET", body = null) => {
  const options = {
    method,
    headers: {
      // "Content-Type": "application/xml",
      "Content-Type": "application/x-www-form-urlencoded",
      "Referrer-Policy": "no-referrer",
    },
  }

  // if (body) {
  //   options.body = body
  // }

  const urlEncodedData = new URLSearchParams(body).toString()
  if (body) {
    options.body = urlEncodedData
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
      options
    )
    console.log("->  response:", response)

    if (!response.ok) {
      const errorData = await response.json()
      const errorMessage =
        errorData.message || `HTTP error! Status: ${response.status}`
      throw new Error(errorMessage)
    }

    const json = await response?.json()
    console.log("->  json:", json)

    if (json?.redirect_url) {
      window.location.href = json?.redirect_url
    }

    return json
  } catch (error) {
    const message = error.message || "An unexpected error occurred."
    toast.error(message, {
      duration: 5000,
    })
    console.error("API call failed:", error)
    throw error // rethrow if you want further handling upstream
  }
}

export const get = (endpoint) => apiClient(endpoint, "GET")
export const post = (endpoint, body) => apiClient(endpoint, "POST", body)
